export default {
    initEnvironment: () => {
        return {
            url: '/logs/initialize',
            method: 'GET'
        };
    }
};



// WEBPACK FOOTER //
// ./environments/logging/api.js